import { Module } from 'cerebral'
import loadMyOrderHistory from './chains/loadMyOrderHistory'
import loadOrderById from './chains/loadOrderById'
import loadForAllUsersOrderHistory from './chains/loadForAllUsersOrderHistory'
import loadAttestOrders from './chains/loadAttestOrders'
import onAttest from './chains/onAttest'
import loadMoreOrders from './chains/loadMoreOrders'
import reOrderBasketItem from './chains/reOrderBasketItem'
import beforeReOrder from './chains/beforeReOrder'

export default Module(({ name, path, controller }) => {
  return {
    state: {
      history: {},
      detail: {},
      limit: 30,
      skip: 0,
      orderHistoryCount: 0,
      attestOrders: {}
    },
    signals: {
      loadMyOrderHistory,
      loadOrderById,
      loadForAllUsersOrderHistory,
      loadAttestOrders,
      onAttest,
      loadMoreOrders,
      reOrderBasketItem,
      beforeReOrder
    }
  }
})



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/index.js